import React, { Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import '../../../../../../styles/adequacoes.scss'

const Componente = (props) => {

    const deletar = async (idSol, IdComp) => {
        props.deletar(idSol, IdComp)
    }
    return (
        <Fragment>
            <tr className="linha-principal">
                <td data-label="Nome">{props.componente.componente.nome}</td>
                <td data-label="Categoria">{props.componente.componente.categoria}</td>
                <td data-label="Tipo">{props.componente.componente.tipo}</td>
                <td data-label="Qtd">{props.componente.qtd}</td>

                <td className="acoes-desktop-cell" title="Excluir" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faTrash}
                        className="mx-2 text-danger cursor-pointer"
                        onClick={() => deletar(props.solic, props.componente._id)}
                    />
                </td>

                {/* ---- CÉLULA EXTRA: GRID DE AÇÕES APENAS PARA MOBILE ----
                     Esta célula fica no DOM sempre, mas será escondida no desktop.
                     No mobile mostramos ela e escondemos as acoes-desktop-cell. */}
                <td className="acoes-mobile-cell">
                    <div className="acoes-mobile">
                        <div className="acao-item" onClick={() => deletar(props.solic, props.componente._id)}>
                            <FontAwesomeIcon icon={faTrash} className="acao-icon text-danger" />
                            <span>Excluir</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td colSpan="3" className="detalhes-local">
                    {props.componente.componente.modeloReferencia}
                </td>
            </tr>
            <tr>
                <td colSpan="3" className="linha-divisoria"></td>
            </tr>
        </Fragment>
    )
}

export default Componente;
